import {saveOrder} from "@/api/order.api";
import {fetchAllCustomers} from "@/api/customer.api";
import Vue from "vue";
import router from "@/router";

const state = {
    fetchingOrders: true,
    orders: [],
    currentOrder: {},
    ordersPageInfo: {
        currentPage: 0,
        pageSize: 10
    }
}

const getters = {
    getCurrentOrder: state => state.currentOrder
}

const actions = {
    async saveOrder({ commit }, request) {
        await saveOrder(request)
            .then(response => {
                commit('setCurrentOrder', response.data)
                router.push('/checkout/receipt')
            })
            .catch(error => {
                console.log(error)
                Vue.notify({
                    group: 'errors',
                    title: 'Greška na serveru',
                    text: 'Doslo je do greške na serveru, molimo Vas pokušajte kasnije'
                })
            })
    },

    async pageOrders({ commit }, { page, pageSize }) {
        commit('setFetchingOrders', true)
        const response = await fetchAllCustomers(page, pageSize)
        commit('setOrders', response.data.content)
        commit('setOrderPageInfo', {
            currentPage: response.data.number,
            totalPages: response.data.totalPages,
            numberOfElements: response.data.numberOfElements,
            totalElements: response.data.totalElements,
            pageSize: response.data.size,
            isFirstPage: response.data.first,
            isLastPage: response.data.last
        })
        commit('setFetchingOrders', false)
    }
}

const mutations = {
    setFetchingOrders: (state, fetchingOrders) => state.fetchingOrders = fetchingOrders,

    setOrders: (state, orders) => state.orders = orders,

    setCurrentOrder: (state, order) => state.currentOrder = order,

    setOrderPageInfo: (state, orderPageInfo) => state.orderPageInfo = orderPageInfo
}

export default {
    state,
    getters,
    actions,
    mutations
}
